/**
 * Feature-local UI for the four-step onboarding flow (S01 → S05).
 *
 * Per code-patterns §3 / §20: feature components live under
 * `features/<name>/components/`. These pieces are not yet shared with another
 * feature — when they are, lift to `apps/web/src/components/` (cross-feature)
 * or `@flint/ui` (workspace-wide). Default is to keep them here.
 *
 * Side effect: `import './onboarding.css'` from the route file (or barrel)
 * once. The CSS supplies the auth-shell grid and the dot-tile background that
 * are tedious to express as Tailwind utilities.
 */
export { OnboardingShell } from "./shell.js";
export type { OnboardingShellProps } from "./shell.js";

export { OnboardingHeader } from "./header.js";
export type { OnboardingHeaderProps } from "./header.js";

export { Stepper } from "./stepper.js";
export type { StepperProps } from "./stepper.js";

export { Hero, HeroNote } from "./hero.js";
export type { HeroProps, HeroNoteProps } from "./hero.js";

export { BrandPanel } from "./brand-panel.js";
export type { BrandPanelProps } from "./brand-panel.js";

export { InsightPanel, InsightKpi } from "./insight-panel.js";
export type { InsightPanelProps, InsightKpiProps } from "./insight-panel.js";

export { StoryList } from "./story-list.js";
export type { StoryItem, StoryListProps } from "./story-list.js";

export { BrandFor } from "./brand-content.js";
export type { BrandStep, BrandForProps } from "./brand-content.js";

export { AccountForm } from "./account-form.js";
export type { AccountFormProps } from "./account-form.js";

/**
 * Bar tooltips for `<Stepper />`. Hardcoded in every onboarding route before;
 * one source now keeps copy aligned across S02–S05.
 */
export const STEP_TITLES = ["Phone", "Verify", "Workspace", "Import"] as const;
